import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么吃瓜群众都选择黑料在线
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-50 text-primary-500 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}